"use strict";

exports.__esModule = true;
exports.AggregateMeasureChartThumbnail = AggregateMeasureChartThumbnail;
var _react = _interopRequireDefault(require("react"));
var _Thumbnails = require("../../Thumbnails");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Thumbnail for MetricChartWidget.
 */
// Defaults now come from BarChartThumbnail itself, which this only forwards to.
function AggregateMeasureChartThumbnail(props) {
  return /*#__PURE__*/_react["default"].createElement(_Thumbnails.BarChartThumbnail, props);
}